import React from 'react';

export default function Heading2(props) {
  return (
    <h2
      style={{
        fontSize: '20px', // Base font size
        textAlign: 'center', // Default alignment
        fontWeight: '500', // Medium font weight
        margin: '0', // Reset margin
      }}
    >
      {props.heading2}
    </h2>
  );
}
